import styled from 'styled-components'

import { PairIcon } from '@root/entities/pair/ui/common'
import { PairHeadline } from '@root/features/pair/ui/mobile/pair-headline'
import { PairSubline } from '@root/features/pair/ui/mobile/pair-subline'

import type { PairModel } from '@root/entities/pair'

type FavoritePairListItemHeaderProps = {
  pair: PairModel
}

export const FavoritePairListItemHeader: React.FC<
  FavoritePairListItemHeaderProps
> = ({ pair }) => {
  return (
    <Root>
      <PairIcon pair={pair} size={39} />
      <Info>
        <PairHeadline pair={pair} />
        <PairSubline pair={pair} withAge />
      </Info>
    </Root>
  )
}

const Root = styled.div`
  padding-inline: 12px;
  padding-block: 12px 8px;
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  align-items: center;
  gap: 6px;
`

const Info = styled.div`
  display: grid;
  align-items: center;
  gap: 3px;
`
